//配置全局访问接口地址http://154.219.115.238:592
let commonUrl = "https://d149w5s0nnfws7.cloudfront.net";//https://d149w5s0nnfws7.cloudfront.net
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl